<template>
  <div class="flex flex-wrap">
    <div class="w-full mt-12 mb-12 px-4">
      <div
        class="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
      >
        <BlogInstanceTableHeader title="post/page instance" />
        <div
          v-if="getLoading"
          class="bg-white w-full flex flex-col py-10 justify-center items-center"
        >
          <!-- https://gannon.tv/intro -->
          <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
          <h3>Loading...</h3>
        </div>
        <BlogInstanceTable
          v-if="!getLoading && getFilteredInstanceInfo.length"
          :InstanceList="InstanceList"
          :componentId="getComponentId('abi_blog')"
        />
        <p
          v-if="!getLoading && !getFilteredInstanceInfo.length"
          class="flex items-center justify-center py-5"
        >
          No Instance Found...
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BlogInstanceTableHeader from "@/components/ComponentModule/InstanceTable/BlogInstanceTableHeader";
import BlogInstanceTable from "@/components/ComponentModule/InstanceTable/BlogInstanceTable";

export default {
  name: "BlogPageInstanceList",
  components: { BlogInstanceTableHeader, BlogInstanceTable },
  mounted() {
    if (!this.getAllComponent.length) {
      this.$store.dispatch(Actions.FETCH_ALL_COMPONENT, {
        region: this.getRegion,
        hardRefresh: false
      });
    } else {
      this.$store.dispatch(Actions.FETCH_INSTANCE_INFO, {
        region: this.getRegion,
        componentId: this.getComponentId("abi_blog")
      });
    }
  },
  watch: {
    getAllComponent() {
      if (this.getAllComponent.length) {
        this.$store.dispatch(Actions.FETCH_INSTANCE_INFO, {
          region: this.getRegion,
          componentId: this.getComponentId("abi_blog")
        });
      }
    }
  },
  computed: {
    InstanceList() {
      if (this.getFilteredInstanceInfo) {
        return this.getFilteredInstanceInfo.map((item) => {
          return {
            id: item.id,
            name: item.instance_name,
            attributes: item.attributes,
            description: item.description
          };
        });
      } else {
        return [];
      }
    },
    ...mapGetters([
      "getAllComponent",
      "getFilteredInstanceInfo",
      "getLoading",
      "getRegion"
    ])
  },
  methods: {
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    }
  }
};
</script>
